"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
require("./Checkbox.css");
var UIProps_1 = require("../../UIProps");
var Icon_1 = require("../../icon/Icon");
var CheckboxTheme;
(function (CheckboxTheme) {
    CheckboxTheme["basic"] = "basic";
})(CheckboxTheme = exports.CheckboxTheme || (exports.CheckboxTheme = {}));
var CheckboxComp = function (_a, ref) {
    var _b = _a.theme, theme = _b === void 0 ? CheckboxTheme.basic : _b, props = __rest(_a, ["theme"]);
    var _c = __read(react_1.useState(props.checked || props.startChecked || false), 2), checked = _c[0], setChecked = _c[1];
    react_1.useEffect(function () {
        if (props.checked !== undefined)
            setChecked(props.checked);
    }, [props.checked]);
    return (React.createElement("label", { className: classnames_1.default('Checkbox', props.className, "Checkbox-" + theme, {
            'Checkbox-disabled': props.disabled,
            'Checkbox-checked': checked,
        }) },
        React.createElement("input", __assign({}, UIProps_1.setUIProps(props), { ref: ref, type: "checkbox", className: 'Checkbox_input', checked: checked, disabled: props.disabled, value: props.value, onChange: function (e) {
                if (props.checked === undefined) {
                    setChecked(function (prevState) {
                        if (props.onChange)
                            props.onChange(!prevState, e);
                        return !prevState;
                    });
                }
                else {
                    if (props.onChange)
                        props.onChange(checked, e);
                }
            } })),
        React.createElement("div", { className: 'Checkbox_toggle' },
            React.createElement(Icon_1.Icon, { type: Icon_1.IconType.check })),
        props.children && (React.createElement("span", { className: "Checkbox_label" }, props.children))));
};
var CheckboxFR = React.forwardRef(CheckboxComp);
exports.Checkbox = React.memo(CheckboxFR);
